module.exports = __webpack_public_path__ + "media/images/emoticons/cloud-0e4e3bf585337fd9f9230b7d0c6cca62.gif";